<template>
    <el-dialog
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            fullscreen
            center>
        <way-point-modal
                v-if="wayPointModalVisible"
                :dialog-visible="wayPointModalVisible"
                @visible-change="
            _visible => {
            wayPointModalVisible = _visible;
            }
            "
                @on-close="handleWayPointModalClose"
                :data="editableWayPoint">
        </way-point-modal>
        <el-tabs type="card" tabPosition="top" stretch value="traks">
            <el-tab-pane name="traks" :label="$t('action.tabs.tracks.name')">
                <div class="tab-viewer">
                    <el-table
                            :data="this.$data.tracks"
                            stripe
                            border
                            ref="trackTable"
                            :row-class-name="tableRowClassName"
                            @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                :label="$t('action.tabs.tracks.tracksGrid.columnName')">
                        </el-table-column>
                        <el-table-column
                                prop="trackStart"
                                :formatter="dateTimeFormat"
                                :label="$t('action.tabs.tracks.tracksGrid.columnTrackStart')">
                        </el-table-column>
                        <el-table-column
                                prop="trackEnd"
                                :formatter="dateTimeFormat"
                                :label="$t('action.tabs.tracks.tracksGrid.columnTrackFinish')">
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane name="map" :label="$t('action.tabs.map.name')" :disabled="disabled">
                <div>
                    <div id="trackCesiumContainer"></div>
                </div>
                <el-button :disabled="disabled" @click="handlFixStart">{{$t('action.tabs.map.buttonFixRaceStart')}}
                </el-button>
                <el-button :disabled="disabled" @click="handleWayPointModalShow(null)">
                    {{$t('action.tabs.map.buttonAddWayPoint')}}
                </el-button>
                <div class="block" style="display: inline-block;">
                    <span style="margin-right: 20px;margin-left: 20px;font: 500 14px system-ui;">{{$t('action.tabs.map.sliderTrail')}}</span>
                    <el-slider style="width: 500px; display: inline-block; vertical-align: middle;"
                               v-model="selectedTrail"
                               :disabled="disabled"
                               :max="3600"
                               :format-tooltip="formatTrailTooltip"
                               @change="handlTrailChange">
                    </el-slider>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('action.tabs.distance.name')" :disabled="this.$data.wayPoints.length == 0">
                <div class="tab-viewer">
                    <el-row>
                        <el-col :span="11">
                            <div class="grid-content">
                                <el-container>
                                    <el-header><span class="header_span">{{$t('action.tabs.distance.wayPointsGrid.name')}}</span>
                                    </el-header>
                                    <el-main style="height: calc(100vh - 310px); overflow-x: scroll; padding-bottom: 0">
                                        <el-table
                                                :data="this.$data.wayPoints"
                                                stripe
                                                border
                                                ref="wayPointsTable"
                                                @row-dblclick="handleWayPointModalShow"
                                                @selection-change="handleSelectionWayPointChange">
                                            <el-table-column
                                                    type="selection">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="name"
                                                    :label="$t('action.tabs.distance.wayPointsGrid.columnName')">
                                            </el-table-column>
                                            <el-table-column
                                                    :label="$t('action.tabs.distance.wayPointsGrid.columnType')"
                                                    fixed="right"
                                                    width="100px"
                                                    align="center">
                                                <template slot-scope="scope">
                                                    <el-popover trigger="hover" placement="top">
                                                        <div v-if="scope.row.gate == undefined">
                                                            <p>Буй: {{ scope.row.mark1.name }}</p>
                                                            <p>Огибания: {{
                                                                wayPointLeaveMarkSideNameFormatter(scope.row.leaveMarkSide)
                                                                }}</p>
                                                        </div>
                                                        <div v-if="scope.row.gate != undefined">
                                                            <p>Буй 1: {{ scope.row.mark1.name }}</p>
                                                            <p>Буй 2: {{ scope.row.mark2.name }}</p>
                                                        </div>
                                                        <div slot="reference" class="name-wrapper">
                                                            <el-tag size="medium">{{
                                                                wayPointTypeNameFormatter(scope.row.gate ) }}
                                                            </el-tag>
                                                        </div>
                                                    </el-popover>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-main>
                                    <el-footer>
                                        <el-button style="margin-top: 12px;"
                                                   :disabled="this.$data.selectedWayPoints.length == 0"
                                                   @click="deleteWayPoint">
                                            {{$t('action.tabs.distance.wayPointsGrid.buttonDelete')}}
                                        </el-button>
                                    </el-footer>
                                </el-container>
                            </div>
                        </el-col>
                        <el-col :span="2">
                            <div class="grid-content" height="100%">
                                <el-container direction="vertical" height="100%">
                                    <el-main style="height: calc(100vh - 190px);">
                                        <el-button
                                                style="width: fit-content; margin: -36px auto 0;display: block; position: relative; top: 50%;"
                                                type="primary" icon="el-icon-arrow-right" circle @click="copyToDistance"
                                                :title="$t('action.tabs.distance.buttonCopySelected')"
                                                :disabled="this.$data.selectedWayPoints.length == 0"></el-button>
                                        <el-button
                                                style="width: fit-content; margin: 4px auto 0;display: block; position: relative; top: 50%;"
                                                icon="el-icon-d-arrow-right" @click="copyAllToDistance"
                                                :title="$t('action.tabs.distance.buttonCopyAll')" circle
                                                :disabled="this.$data.wayPoints.length == 0"></el-button>
                                    </el-main>
                                </el-container>
                            </div>
                        </el-col>
                        <el-col :span="11">
                            <div class="grid-content">
                                <el-container>
                                    <el-header><span class="header_span">{{$t('action.tabs.distance.distanceGrid.name')}}</span>
                                    </el-header>
                                    <el-main
                                            style="height: calc(100vh - 310px); overflow-x: scroll; padding-bottom: 0px;">
                                        <el-table
                                                :data="this.$data.distance"
                                                stripe
                                                border
                                                @selection-change="handleSelectionDistanceWayPointChange">
                                            <el-table-column
                                                    type="selection">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="name"
                                                    :label="$t('action.tabs.distance.distanceGrid.columnName')">
                                            </el-table-column>
                                            <el-table-column
                                                    :label="$t('action.tabs.distance.distanceGrid.columnType')"
                                                    fixed="right"
                                                    width="100px"
                                                    align="center">
                                                <template slot-scope="scope">
                                                    <el-popover trigger="hover" placement="top">
                                                        <div v-if="scope.row.gate == undefined">
                                                            <p>Буй: {{ scope.row.mark1.name }}</p>
                                                            <p>Огибания: {{
                                                                wayPointLeaveMarkSideNameFormatter(scope.row.leaveMarkSide)
                                                                }}</p>
                                                        </div>
                                                        <div v-if="scope.row.gate != undefined">
                                                            <p>Буй 1: {{ scope.row.mark1.name }}</p>
                                                            <p>Буй 2: {{ scope.row.mark2.name }}</p>
                                                        </div>
                                                        <div slot="reference" class="name-wrapper">
                                                            <el-tag size="medium">{{
                                                                wayPointTypeNameFormatter(scope.row.gate) }}
                                                            </el-tag>
                                                        </div>
                                                    </el-popover>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    fixed="right"
                                                    width="50px"
                                                    align="right">
                                                <template slot-scope="scope">
                                                    <div>
                                                        <el-button type="text" @click="rowUpDown(scope.row, -1)"
                                                                   icon="el-icon-arrow-up"
                                                                   :disabled="isFirstRow($data.distance, scope.row)"></el-button>
                                                        <el-button type="text" @click="rowUpDown(scope.row, +1)"
                                                                   icon="el-icon-arrow-down"
                                                                   :disabled="isLastRow($data.distance, scope.row)"></el-button>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-main>
                                    <el-footer>
                                        <el-button style="margin-top: 12px;"
                                                   :disabled="this.selectedDistanceWayPoints.length == 0"
                                                   @click="deleteWayPointFromDistance">
                                            {{$t('action.tabs.distance.distanceGrid.buttonDelete')}}
                                        </el-button>
                                    </el-footer>
                                </el-container>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('action.tabs.parameters.name')" :disabled="disabled">
                <div class="tab-viewer">
                    <el-form label-position="right" label-width="10%" :model="$data.raceParams" :rules="$data.rules"
                             ref="raceForm">
                        <el-form-item label="ID" prop="raceId">
                            <el-input type="text" v-model="$data.raceParams.raceId" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('action.tabs.parameters.editForm.fieldRaceName')" prop="raceName">
                            <el-input type="text"
                                      :placeholder="$t('action.tabs.parameters.editForm.placeHolder.fieldRaceName')"
                                      v-model="$data.raceParams.raceName"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('action.tabs.parameters.editForm.fieldRaceInterval')"
                                      prop="selectedIntreval">
                            <el-date-picker
                                    v-model="$data.raceParams.selectedIntreval"
                                    type="datetimerange"
                                    :range-separator="$t('action.tabs.parameters.editForm.placeHolder.fieldRaceIntervalRangeSeparator')"
                                    align="right"
                                    :start-placeholder="$t('action.tabs.parameters.editForm.placeHolder.fieldRaceIntervalStart')"
                                    :end-placeholder="$t('action.tabs.parameters.editForm.placeHolder.fieldRaceIntervalFinish')"
                                    default-value="2010-10-01"
                                    value-format="timestamp"
                                    :format="$t('common.dateTimeFullFormatTemplate')">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item :label="$t('action.tabs.parameters.editForm.fieldRaceStart')"
                                      prop="selectedStartTime">
                            <el-date-picker type="datetime"
                                            value-format="timestamp"
                                            :format="$t('common.dateTimeFullFormatTemplate')"
                                            v-model="$data.raceParams.selectedStartTime"></el-date-picker>
                        </el-form-item>
                        <el-form-item :label="$t('action.tabs.parameters.editForm.fieldRaceType.name')" prop="raceType">
                            <el-radio-group v-model="$data.raceParams.raceType" size="medium">
                                <el-radio-button :label="1">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceType.values.race')}}
                                </el-radio-button>
                                <el-radio-button :label="2">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceType.values.startTrening')}}
                                </el-radio-button>
                                <el-radio-button :label="5">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceType.values.tuningForSpeed')}}
                                </el-radio-button>
                                <el-radio-button :label="3" disabled="">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceType.values.track')}}
                                </el-radio-button>
                                <el-radio-button :label="4" disabled="">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceType.values.monitoring')}}
                                </el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('action.tabs.parameters.editForm.fieldRaceStatus.name')"
                                      prop="raceStatus">
                            <el-radio-group v-model="$data.raceParams.raceStatus" size="medium">
                                <el-radio-button :label="1">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceStatus.values.hidden')}}
                                </el-radio-button>
                                <el-radio-button :label="2">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceStatus.values.disabled')}}
                                </el-radio-button>
                                <el-radio-button :label="3">
                                    {{$t('action.tabs.parameters.editForm.fieldRaceStatus.values.active')}}
                                </el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('action.tabs.video.name')" :disabled="this.data.editableRace == null">
                <div class="tab-viewer">
                    <!--:model="dynamicVideoForm"-->
                    <el-form ref="dynamicVideoForm">
                        <el-form-item
                                v-for="(item, index) in raceVideos"
                                :prop="'details[' + index + '].amount'"
                                :key="item.key"
                                inline="true"
                                label-position="left"
                        >
                            <el-row v-if="!item.deleted" :gutter="20">
                                <el-col :span="10">
                                    <el-form-item label="Файл">
                                        <el-input v-model="item.file">
                                            <template slot="prepend">https://www.youtube.com/watch?v=</template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="Сдвиг от начала гонки:">
                                        <el-input-number v-model="item.shiftStart" controls-position="right" :min="0" :max="86400"></el-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="Время воспроизведения:">
                                        <el-input-number v-model="item.playTime" controls-position="right" :min="0" :max="86400"></el-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col style="margin-left: 5px" :span="1">
                                    <el-button
                                            type="text"
                                            @click="removeVideo(index);"
                                            icon="el-icon-close"
                                    >
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-button type="text" @click="addVideo">Добавить видео</el-button>
                    </el-form>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-footer align="right" style="height: 36px;">
            <el-button @click="handleSave" type="primary">{{$t('action.buttonSave')}}</el-button>
            <el-button @click="handleClose">{{$t('action.buttonClose')}}</el-button>
        </el-footer>
    </el-dialog>
</template>

<script>
    import Vue from 'vue';
    import 'element-ui/lib/theme-chalk/display.css';
    import {format, isBefore} from 'date-fns';
    import WayPointModal from "./WayPointModal";
    import Utils from '@/utils';
    import DistanceUtils from '@/api/distance';
    import RaceUtils from '@/api/race';
    //import StatWorker from 'worker-loader!@/js/statsWorker.js'
    import {publicUrl} from "@/api/base";

    export default {
        name: "EditRaceModal",
        components: {
            WayPointModal
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            var checkDateTimeRange = (rule, value, callback) => {
                if (value == undefined || value == null || value.length != 2) {
                    callback(new Error('Please pick a date range'));
                }
                if (value[0] == undefined || value[0] == null) {
                    callback(new Error('Please pick a date start'));
                }
                if (value[1] == undefined || value[1] == null) {
                    callback(new Error('Please pick a date finish'));
                }
                let dateStart = new Date(value[0]);
                let dateFinish = new Date(value[1]);
                if (isBefore(dateFinish, dateStart)) {
                    callback(new Error('date start must before finish'));
                }
                callback();
            };
            return {
                raceParams: {
                    raceId: null,
                    raceName: '',
                    selectedIntreval: '',
                    selectedStartTime: '',
                    raceType: 1,
                    raceStatus: 1,
                    distanceId: null
                },
                trackSelection: [],
                selectedTrail: 360,
                counter: 0,
                disabled: true,
                wayPointModalVisible: false,
                wayPoints: [],
                selectedWayPoints: [],
                distance: [],
                selectedDistanceWayPoints: [],
                raceEntrys: new Map(),
                editableWayPoint: '',
                rules: {
                    raceName: [
                        {required: true, message: 'Please input Activity name', trigger: 'blur'},
                        {min: 3, message: 'Length should be > 3 ', trigger: 'blur'}
                    ],
                    selectedStartTime: [
                        {required: true, message: 'Please pick a time', trigger: 'change'}
                    ],
                    selectedIntreval: [
                        {required: true, validator: checkDateTimeRange, trigger: 'blur'}
                    ],
                    raceType: [
                        {required: true, message: 'Please input Race Type', trigger: 'blur'}
                    ],
                    raceStatus: [
                        {required: true, message: 'Please input Race Status', trigger: 'blur'}
                    ]
                },
                tracks: [],
                raceVideos: []
            }
        },
        mounted: function () {
            this.$nextTick(_ => {
                if (!window.viewer) {
                    window.Cesium.CallbackProperty.prototype.getValueInReferenceFrame = function (time, referenceFrame, result) {
                        return this._callback(time, result);
                    };
                    let providerViewModels = [];
                    providerViewModels.push(new window.Cesium.ProviderViewModel({
                        name: 'ESRI World Imagery',
                        tooltip: '',
                        iconUrl: window.window.Cesium.buildModuleUrl('Widgets/Images/ImageryProviders/esriWorldImagery.png'),
                        creationFunction: function () {
                            return new window.window.Cesium.ArcGisMapServerImageryProvider({
                                url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
                                enablePickFeatures: false
                            });
                        }
                    }));

                    window.viewer = new window.Cesium.Viewer('trackCesiumContainer', {
                        imageryProviderViewModels: providerViewModels,
                        selectedImageryProviderViewModel: providerViewModels[2],
                        terrainProviderViewModels: [], // Disable terrain changing
                        infoBox: true, // Disable InfoBox widget
                        selectionIndicator: false, // Disable selection indicator
                        sceneMode: window.Cesium.SceneMode.SCENE3D,
                        mapMode2D: window.Cesium.MapMode2D.ROTATE,
                        timeline: false,
                        animation: false,
                        requestRenderMode: true
                    });
                    window.viewer.extend(window.Cesium.sliderMixin, {
                        Vue, format
                    });
                    window.viewer.extend(window.Cesium.viewerCesiumNavigationMixin, {});
                    window.viewer.slider.$on('limitsChange', val => {
                        this.$data.raceParams.selectedIntreval = val;
                    });
                    this.initCeziumHandler(window.viewer);
                }
                if (window.viewer.dataSources.length) {
                    window.viewer.dataSources.removeAll();
                }
                //Загрузка треков в грид
                let traksFromEvent = []; //let traksFromEvent = this.data.races.filter((item) => { return Utils.raceIsTrackType(item);});
                //Загрузка данных редактируемой гонки
                if (this.data.editableRace != null && this.data.editableRace != undefined) {
                    let usedDevices = this.data.editableRace.entrys.map(function (el) {
                        return el.boat.device.id
                    });
                    this.data.races.forEach((race) => {
                        if (race.id === this.data.editableRace.id) {
                            this.raceParams.raceId = race.id;
                            this.raceParams.raceName = race.name;
                            this.raceParams.raceType = race.type.id;
                            this.raceParams.raceStatus = race.status.id;
                            this.raceParams.selectedStartTime = new Date(race.raceStart);
                            this.raceParams.selectedIntreval = [race.trackStart, race.trackEnd];
                            if (race.distance != undefined && race.distance != null) {
                                this.raceParams.distanceId = race.distance.id;
                            }
                            this.raceVideos = race.videos;
                            traksFromEvent.unshift(race);
                            //this.$data.tracks = traksFromEvent;
                            this.$nextTick(_ => {
                                this.$refs.trackTable.toggleRowSelection(this.$data.tracks[0]);
                            });
                        } else {
                            if (this.isTrack(race)) {
                                let raceDevices = race.entrys.map(function (el) {
                                    return el.boat.device.id
                                });
                                let isUsedTrack = false;
                                for (let i = 0; i < raceDevices.length; i++) {
                                    if (usedDevices.includes(raceDevices[i])) {
                                        isUsedTrack = true;
                                        break;
                                    }
                                }
                                if (!isUsedTrack) {
                                    traksFromEvent.push(race);
                                }
                            }
                        }
                    })
                } else {
                    traksFromEvent = this.data.races.filter((item) => {
                        return Utils.raceIsTrackType(item);
                    });
                }
                this.$data.tracks = traksFromEvent;
            });
        },
        methods: {
            handleClose: function () {
                this.closeWindow();
                this.$emit("visible-change", false);
            },
            closeWindow: function () {
                window.viewer.slider.destroy();
                window.viewer.entities.removeAll();
                window.viewer.dataSources.removeAll();
                window.viewer.shouldAnimate = false;
                window.viewer.destroy();
                window.viewer = null;
                console.log('handleClose');
            },
            handleSelectionChange(val) {
                if (val.length > this.$data.trackSelection.length) {
                    //Add ctrack
                    for (var i = 0; i < val.length; i++) {
                        if (this.$data.trackSelection.indexOf(val[i]) < 0) {
                            this.loadTrack(val[i], val.length);
                        }
                    }
                } else {
                    if (val.length > 0) {
                        //Find Removable track
                        for (var i = 0; i < this.$data.trackSelection.length; i++) {
                            if (val.indexOf(this.$data.trackSelection[i]) < 0) {
                                this.removeTrack(this.$data.trackSelection[i]);
                            }
                        }
                    } else {
                        //Remove last track
                        //alert('Remove ' + this.$data.trackSelection[0].name);
                        this.removeTrack(this.$data.trackSelection[0]);
                        //window.viewer.dataSources.removeAll();
                    }
                }
                this.$data.trackSelection = val;
                this.$data.disabled = !(val.length > 0);
                console.log('disabled: ' + this.$data.disabled);
                console.log(val);
            },
            removeTrack: function (track) {
                this.$nextTick(_ => {
                    if (!this.removeEntityById(track.entrys[0].boat.device.id)) {
                        Utils.showMessage(this, "Внимание!", "Ошибка при удалении трека " + track.name);
                        //alert('Entity ' + track.name + ' not found');
                        return;
                    }
                    let timeStart, timeFinish;
                    timeStart = window.Cesium.JulianDate.toDate(window.viewer.dataSources.get(0).clock.startTime).getTime();
                    timeFinish = window.Cesium.JulianDate.toDate(window.viewer.dataSources.get(0).clock.stopTime).getTime();
                    this.updateTimeLineInterval(timeStart, timeFinish);
                });
            },
            removeEntityById: function (id) {
                let entity = null;
                for (var i = 0; window.viewer.dataSources.length; i++) {
                    entity = window.viewer.dataSources.get(i).entities.getById(id);
                    if (entity != undefined && entity != null) {
                        window.viewer.dataSources.get(i).entities.remove(entity);
                        this.removeRaceEntry(id);
                        return true;
                    }
                }
                return false;
            },
            loadTrack: function (track, numberOfColor) {
                console.log(JSON.stringify(track));
                this.$nextTick(_ => {
                    let modelColors = [window.window.Cesium.Color.RED, window.window.Cesium.Color.ORANGE, window.window.Cesium.Color.GREEN, window.window.Cesium.Color.LIGHTSKYBLUE, window.window.Cesium.Color.DARKBLUE, window.window.Cesium.Color.BLACK];
                    let initString = [{"version": "1.0", "id": "document"}];
                    let _this = this;
                    let oldCurrentTime = window.viewer.clock.currentTime;
                    let isNeedReturnSelectedTimeInterval = (this.data.editableRace != undefined && this.data.editableRace != null && this.data.editableRace.id != track.id) ? true : false;
                    window.viewer.dataSources.add(window.window.Cesium.CzmlDataSource.load(initString)).then(function (dataSource) {
                        window.window.Cesium.loadText(publicUrl + 'ws/czml/degrees?raceId=' + track.id).then(function (czml) {
                            track.entrys.forEach((entry) => {
                                let entity = dataSource.entities.add({
                                    id: entry.boat.device.id,
                                    ipctype: Utils.BOAT_TYPE(),
                                    position: new window.window.Cesium.SampledPositionProperty(window.window.Cesium.ReferenceFrame.FIXED, 0),
                                    label: {
                                        text: entry.competitor.shortName,
                                        scale: 0.5,
                                        eyeOffset: new window.Cesium.Cartesian3(0, 5.0, 0),
                                        horizontalOrigin: window.window.Cesium.HorizontalOrigin.CENTER,
                                        verticalOrigin: window.window.Cesium.VerticalOrigin.BOTTOM,
                                        font: "700 42px Roboto",
                                        style: window.window.Cesium.LabelStyle.FILL_AND_OUTLINE,
                                        outlineWidth: 5,
                                        outlineColor: window.window.Cesium.Color.BLACK,
                                    },
                                    // model: {
                                    //     uri: (entry.boat.sportClass == null || entry.boat.sportClass == undefined)?'models/rubber.glb':'models/' + entry.boat.sportClass.modelFileUri,
                                    //     minimumPixelSize: 15,
                                    //     shadows: window.window.Cesium.ShadowMode.CAST_ONLY,
                                    //     scale: 0.6,
                                    //     runAnimations: true
                                    // },
                                    path: {
                                        leadTime: 0.0,
                                        trailTime: 60,
                                        resolution: 2,
                                        show: true,
                                        material: new window.window.Cesium.ColorMaterialProperty(modelColors[numberOfColor]),
                                        width: 1.0
                                    }
                                });
                                Utils.updateEntityModel(entity, entry.boat.sportClass, window.Cesium, window.viewer);
                                entity.orientation = new window.window.Cesium.VelocityOrientationProperty(entity.position);
                                _this.raceEntrys.set(entry.boat.device.id, _this.createRaceEntry(isNeedReturnSelectedTimeInterval ? null : entry.id, entry.boat, entry.competitor));
                            });
                            if (track.distance != undefined && track.distance != null) {
                                if (track.distance.wayPoints != undefined && track.distance.wayPoints != null) {
                                    track.distance.wayPoints.forEach((wp) => {
                                        let index = Utils.existWayPoint(_this.wayPoints, wp.id);
                                        let wayPoint;
                                        if (index < 0) {
                                            wayPoint = {
                                                id: wp.id,
                                                name: wp.name,
                                                mark1: null,
                                                mark2: null,
                                                gate: null
                                            };
                                            if (wp.mark1.fixed) {
                                                wayPoint.mark1 = _this.createMark(wp.mark1.id, wp.mark1.name);
                                                Utils.updateEntityModel(wayPoint.mark1, wp.mark1.sportClass, window.Cesium, window.viewer);
                                                wayPoint.leaveMarkSide = wp.leaveMarkSide;
                                                wayPoint.mark1.position.setValue(
                                                    window.window.Cesium.Cartesian3.fromDegrees(wp.mark1.longitude, wp.mark1.latitude)
                                                );
                                                wayPoint.mark1.ipctype = Utils.FIXED_MARK_TYPE();
                                            } else {
                                                //Пока не обрабатываю
                                            }
                                            if (wp.mark2 != undefined && wp.mark2 != null) {
                                                if (wp.mark2.fixed) {
                                                    wayPoint.mark2 = _this.createMark(wp.mark2.id, wp.mark2.name);
                                                    Utils.updateEntityModel(wayPoint.mark2, wp.mark2.sportClass, window.Cesium, window.viewer);
                                                    wayPoint.mark2.position.setValue(
                                                        window.window.Cesium.Cartesian3.fromDegrees(wp.mark2.longitude, wp.mark2.latitude)
                                                    );
                                                    wayPoint.mark2.ipctype = Utils.FIXED_MARK_TYPE();
                                                } else {
                                                    //Пока не обрабатываю
                                                }
                                                wayPoint.gate = _this.createGate(_this.$data.counter++, wayPoint.mark1, wayPoint.mark2, wayPoint.name);
                                            }
                                            _this.wayPoints.push(wayPoint);
                                        } else {
                                            wayPoint = _this.wayPoints[index];
                                        }
                                        _this.distance.push(Object.assign({}, wayPoint));
                                    });
                                }
                            }
                            dataSource.process(JSON.parse(czml)).then(function (dataSource1) {
                                window.viewer.flyTo(dataSource1.entities);
                                if (!isNeedReturnSelectedTimeInterval) {
                                    let timeStart, timeFinish;
                                    timeStart = window.Cesium.JulianDate.toDate(dataSource1.clock.startTime).getTime();
                                    timeFinish = window.Cesium.JulianDate.toDate(dataSource1.clock.stopTime).getTime();
                                    window.viewer.slider.setTimelineInterval(
                                        timeStart,
                                        timeFinish
                                    );
                                    window.viewer.clock.currentTime = dataSource1.clock.stopTime;
                                    window.viewer.shouldAnimate = false;
                                    window.viewer.slider.$emit('limitsChange', [timeStart, timeFinish]);
                                } else {
                                    window.viewer.clock.currentTime = oldCurrentTime;
                                }
                            }).otherwise(function (e) {
                                console.log(e.message ? e.message : e);
                            });
                        }).otherwise(function (e) {
                            console.log(e.message ? e.message : e);
                        });
                    });
                });

                //Загружаю данные в воркер
                // if(this.statsWorker != null && this.statsWorker != null) {
                //     this.statsWorker.postMessage({cmd:'init', value: track });
                // }
            },
            updateTimeLineInterval: function (timeStart, timeFinish) {
                window.viewer.slider.setTimelineInterval(
                    timeStart,
                    timeFinish
                );
                if (timeStart <= timeFinish) {
                    window.viewer.slider.$emit('limitsChange', [timeStart, timeFinish]);
                }
            },
            initCeziumHandler: function (viewer) {
                let dragging = false;
                let movingObject = null;
                const mousePosition = new window.window.Cesium.Cartesian2();
                const mousePositionProperty = new window.window.Cesium.CallbackProperty(function (time, result) {
                    var position = scene.camera.pickEllipsoid(mousePosition, undefined, result);
                    var cartographic = window.window.Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
                    cartographic.height = 0.0;
                    return window.window.Cesium.Ellipsoid.WGS84.cartographicToCartesian(cartographic);
                }, false);

                const handler = new window.window.Cesium.ScreenSpaceEventHandler(viewer.canvas);
                const scene = viewer.scene;

                handler.setInputAction(
                    function (click) {
                        var pickedObject = scene.pick(click.position);
                        if (window.window.Cesium.defined(pickedObject) && pickedObject.id.ipctype != undefined && pickedObject.id.ipctype == Utils.FIXED_MARK_TYPE()) {
                            dragging = true;
                            movingObject = pickedObject.id;
                            scene.screenSpaceCameraController.enableRotate = false;
                            window.window.Cesium.Cartesian2.clone(click.position, mousePosition);
                            movingObject.position = mousePositionProperty;
                        }
                    },
                    window.window.Cesium.ScreenSpaceEventType.LEFT_DOWN
                );

                handler.setInputAction(
                    function (movement) {
                        if (dragging) {
                            window.window.Cesium.Cartesian2.clone(movement.endPosition, mousePosition);
                        }
                    },
                    window.window.Cesium.ScreenSpaceEventType.MOUSE_MOVE
                );


                handler.setInputAction(
                    function (click) {
                        if (dragging) {
                            dragging = false;
                            scene.screenSpaceCameraController.enableRotate = true;
                            movingObject.position = scene.camera.pickEllipsoid(click.position);
                            //let coordinate = window.window.Cesium.Cartographic.fromCartesian(movingObject.position.getValue(viewer.clock.currentTime));
                            //alert('New point ' +  movingObject.name + ' longitude: ' + window.window.Cesium.Math.toDegrees(coordinate.longitude) + ', latitude: ' + window.window.Cesium.Math.toDegrees(coordinate.latitude));
                        }
                    },
                    window.window.Cesium.ScreenSpaceEventType.LEFT_UP
                );
            },
            dateTimeFormat: function (row, column, cellValue) {
                if (cellValue == undefined) return '';
                return format(new Date(cellValue), 'DD.MM.YY HH:mm');
            },
            handlFixStart: function () {
                this.raceParams.selectedStartTime = window.window.Cesium.JulianDate.toDate(window.viewer.clock.currentTime).getTime(); // window.viewer.clock.currentTime.getTime();
                this.$message({
                    type: 'success',
                    message: this.$t('action.tabs.map.eventFixRaceStart')
                });
            },
            handlTrailChange: function (val) {
                if (window.viewer && window.viewer.dataSources) {
                    let entity;
                    let ds;
                    for (var i = 0; window.viewer.dataSources.length > i; i++) {
                        ds = window.viewer.dataSources.get(i);
                        for (var j = 0; ds.entities.values.length > j; j++) {
                            entity = ds.entities.values[j];
                            console.log(entity.id + ': ' + entity.label.text + ' => ' + entity.ipctype);
                            if (entity != undefined && entity != null && entity.ipctype != undefined && entity.ipctype == 'boat') {
                                entity.path.trailTime = val;
                            }
                        }
                    }
                }
            },
            formatTrailTooltip: function (val) {
                this.handlTrailChange(val);
                return val;
            },
            handleWayPointModalShow: function (data) {
                console.log('Show Get Gatec Name Modal');
                if (data != undefined && data != null) {
                    this.editableWayPoint = Object.assign({}, data);
                } else {
                    this.editableWayPoint = {
                        name: '',
                        type: 1,
                        mark1: {name: ''},
                        mark2: {name: ''},
                        leaveMarkSide: 1
                    }
                }
                console.log(this.editableWayPoint);
                this.wayPointModalVisible = true;
            },
            handleWayPointModalClose: function (data) {
                console.log('Show Get Gatec Name Modal');
                this.wayPointModalVisible = false;
                if (data != null) {
                    //alert(JSON.stringify(data.id));
                    if (data.id == undefined || data.id == null) {
                        let wayPoint = {
                            id: Utils.getTemporaryIndex(this.counter++),
                            name: data.name,
                            mark1: null,
                            mark2: null,
                            gate: null
                        };
                        if (data.mark2 == undefined || data.mark2 == null) {
                            wayPoint.mark1 = this.createMark(Utils.getTemporaryIndex(this.$data.counter++), data.mark1.name);
                            Utils.updateEntityModel(wayPoint.mark1, data.sportClass, window.Cesium, window.viewer);
                            wayPoint.leaveMarkSide = data.leaveMarkSide;
                        } else {
                            wayPoint.mark1 = this.createMark(Utils.getTemporaryIndex(this.$data.counter++), data.mark1.name);
                            Utils.updateEntityModel(wayPoint.mark1, data.sportClass, window.Cesium, window.viewer);
                            wayPoint.mark2 = this.createMark(Utils.getTemporaryIndex(this.$data.counter++), data.mark2.name);
                            Utils.updateEntityModel(wayPoint.mark2, data.sportClass, window.Cesium, window.viewer);
                            wayPoint.gate = this.createGate(Utils.getTemporaryIndex(this.$data.counter++), wayPoint.mark1, wayPoint.mark2, wayPoint.name);
                        }
                        this.$data.wayPoints.push(wayPoint);
                    } else {
                        let changedWayPoint = this.wayPoints.map((item, index) => {
                            if (item.id === data.id) {
                                return index;
                            } else {
                                return -1;
                            }
                        }).filter((val) => {
                            return val >= 0;
                        });
                        if (changedWayPoint != undefined && changedWayPoint != null && Array.isArray(changedWayPoint)) {
                            changedWayPoint.forEach((index) => {
                                let wp = this.wayPoints[index];
                                wp.name = data.name;
                                wp.mark1 = data.mark1;
                                wp.mark1.label.text = wp.mark1.name;
                                Utils.updateEntityModel(wp.mark1, data.sportClass, window.window.Cesium);
                                //Делаю проверку на изменение типа mark => gate или gate => mark
                                if (wp.gate != null && data.gate != null && data.mark2 != null) {
                                    //Тип сохранился. Ворота. Нужно прсото переименовать объекты
                                    wp.mark2 = data.mark2;
                                    wp.mark2.label.text = wp.mark2.name;
                                    Utils.updateEntityModel(wp.mark2, data.sportClass, window.window.Cesium, window.viewer);
                                    wp.gate = data.gate;
                                    wp.gate.label.text = wp.gate.name;
                                } else if (wp.gate != null && (data.gate == null || data.mark2 == undefined)) {
                                    //Поменялся тип gate => mark
                                    // remove gate, mark2
                                    window.viewer.entities.remove(wp.gate);
                                    window.viewer.entities.remove(wp.mark2);
                                    delete wp.gate;
                                    delete wp.mark2;
                                } else if (wp.gate == null && data.mark2 != null) {
                                    //Поменялся тип mark => gate
                                    // create mark2, gate
                                    let coordinate = window.window.Cesium.Cartographic.fromCartesian(wp.mark1.position.getValue(window.viewer.clock.currentTime));
                                    wp.mark2 = this.createMark(Utils.getTemporaryIndex(this.$data.counter++), data.mark2.name, data.sportClass, coordinate.longitude, coordinate.latitude);
                                    wp.gate = this.createGate(Utils.getTemporaryIndex(this.$data.counter++), wp.mark1, wp.mark2, wp.name);
                                }
                                Vue.set(this.wayPoints, index, wp);
                                let changedInDistance = this.distance.map((d, index) => {
                                    if (d.id == wp.id) {
                                        return index;
                                    } else {
                                        return -1;
                                    }
                                }).filter((val) => {
                                    return val >= 0;
                                });
                                console.log('changedInDistance' + JSON.stringify(changedInDistance));
                                if (changedInDistance != undefined && changedInDistance != null) {
                                    changedInDistance.forEach((index) => {
                                        Vue.set(this.distance, index, Object.assign({}, wp));
                                    });
                                }
                            });
                        }
                    }
                }
            },
            wayPointTypeNameFormatter: function (val) {
                if (val == undefined) {
                    return 'Буй';
                } else {
                    return 'Ворота';
                }
            },
            wayPointLeaveMarkSideNameFormatter: function (val) {
                switch (val) {
                    case 0:
                        return 'Справа';
                    case 1:
                        return 'Слева';
                    default:
                        return 'Не установлено';
                }
            },
            deleteWayPoint: function () {
                let deletedWayPointIds = [];
                this.selectedWayPoints.forEach((item) => {
                    deletedWayPointIds.push(item.id);
                    if (item.gate == undefined) {
                        window.viewer.entities.remove(item.mark1);
                    } else {
                        window.viewer.entities.remove(item.gate);
                        window.viewer.entities.remove(item.mark1);
                        window.viewer.entities.remove(item.mark2);
                    }
                });
                this.deleteItemFromArray(this.selectedWayPoints, this.wayPoints);
                let clearArray = this.distance.filter(function (item) {
                    if (deletedWayPointIds.indexOf(item.id) < 0) {
                        return item;
                    }
                });
                this.distance = clearArray;
            },
            handleSelectionWayPointChange: function (val) {
                this.selectedWayPoints = val;
            },
            copyAllToDistance: function () {
                this.wayPoints.forEach((item) => {
                    this.distance.push(Object.assign({}, item));
                });
            },
            copyToDistance: function () {
                this.selectedWayPoints.forEach((item) => {
                    this.distance.push(Object.assign({}, item));
                });
            },
            handleSelectionDistanceWayPointChange: function (val) {
                this.selectedDistanceWayPoints = val;
            },
            deleteWayPointFromDistance: function () {
                this.deleteItemFromArray(this.selectedDistanceWayPoints, this.distance);
            },
            deleteItemFromArray: function (sourceArray, targetArray) {
                let index;
                sourceArray.forEach((item) => {
                    index = targetArray.indexOf(item);
                    if (index !== -1) targetArray.splice(index, 1);
                });
                sourceArray.splice(0, sourceArray.length);
            },
            createMark: function (id, markName, longitude, latitude) {
                let coordinates = window.window.Cesium.Rectangle.center(window.viewer.camera.computeViewRectangle());
                let mark = window.viewer.entities.add({
                    name: markName,
                    id: id,
                    ipctype: Utils.FIXED_MARK_TYPE(),
                    position: window.window.Cesium.Cartesian3.fromRadians(
                        ((longitude == null || longitude == undefined) ? coordinates.longitude : longitude) + window.window.Cesium.Math.randomBetween(0, 0.00001),
                        ((latitude == null || latitude == undefined) ? coordinates.latitude : latitude) + window.window.Cesium.Math.randomBetween(0, 0.00001),
                        0.0
                    ),
                    label: {
                        text: markName,
                        scale: 0.5,
                        eyeOffset: new window.window.Cesium.Cartesian3(0.0, 11.0, -5.0),
                        horizontalOrigin: window.window.Cesium.HorizontalOrigin.CENTER,
                        verticalOrigin: window.window.Cesium.VerticalOrigin.BOTTOM,
                        font: "700 42px Roboto",
                        style: window.window.Cesium.LabelStyle.FILL_AND_OUTLINE,
                        outlineWidth: 5,
                        outlineColor: window.window.Cesium.Color.BLACK,
                    }
                });
                return mark;
            },
            createGate: function (id, mark1, mark2, gateName) {
                let gate = window.viewer.entities.add({
                    id: id,
                    ipctype: Utils.GATE_TYPE(),
                    label: {
                        text: gateName,
                        scale: 0.5,
                        eyeOffset: new window.window.Cesium.Cartesian3(0.0, 11.0, -5.0),
                        horizontalOrigin: window.window.Cesium.HorizontalOrigin.CENTER,
                        verticalOrigin: window.window.Cesium.VerticalOrigin.BOTTOM,
                        font: "700 42px Roboto",
                        style: window.window.Cesium.LabelStyle.FILL_AND_OUTLINE,
                        outlineWidth: 5,
                        outlineColor: window.window.Cesium.Color.BLACK,
                    },
                    polyline: new window.window.Cesium.PolylineGraphics({
                        show: true,
                        followSurface: false,
                        width: 3,
                        material: new window.window.Cesium.ColorMaterialProperty(window.window.Cesium.Color.fromCssColorString('#779999')),
                        positions: new window.window.Cesium.PositionPropertyArray([
                            new window.window.Cesium.ReferenceProperty(window.viewer.entities, mark1.id, ['position']),
                            new window.window.Cesium.ReferenceProperty(window.viewer.entities, mark2.id, ['position'])
                        ])
                    })
                });
                return gate;
            },
            addRaceEntry: function (id, boat, competitor) {
                this.raceEntrys.pus({
                    id: id,
                    boat: boat,
                    competitor: competitor
                });
            },
            removeRaceEntry: function (id) {
                this.raceEntrys.delete(id);
            },
            rowUpDown: function (row, cnt) {
                let index = this.$data.distance.indexOf(row);
                if ((index + cnt) < 0 || (index + cnt) >= this.$data.distance.length) return;
                let dist = this.$data.distance.slice(0);
                dist[index + cnt] = this.$data.distance[index];
                dist[index] = this.$data.distance[index + cnt];
                this.$data.distance = dist;
            },
            isFirstRow: function (arr, row) {
                if (arr.indexOf(row) == 0) return true;
                return false;
            },
            isLastRow: function (arr, row) {
                if (arr.indexOf(row) >= (arr.length - 1)) return true;
                return false;
            },
            handleSave: function () {
                this.validateForm('raceForm');
            },
            validateForm: function (formName) {
                if (this.distance == undefined || this.distance == null || this.distance.length <= 0) {
                    Utils.showMessage(this, this.$t('action.action.errorData'), this.$t('action.action.errorDistanceMessage'));
                    return;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //alert('А вот тут начинается самое интересное. Все готово к созданию гонки!');
                        this.createRace();
                    } else {
                        Utils.showMessage(this, this.$t('action.action.errorData'), this.$t('action.action.errorDataMessage'));
                    }
                });
            },
            tableRowClassName({row, rowIndex}) {
                return Utils.tableRowClassName({row, rowIndex});
            },
            createRace: function () {
                this.loading = true;
                //Создание дистанции
                let newDistance = {
                    id: this.raceParams.distanceId,
                    name: 'Distance for race ' + this.raceParams.raceName,
                    deleted: false,
                    sportClass: {"id": 21},
                    event: {"id": this.data.id},
                    wayPoints: []
                };
                this.distance.forEach((wp) => {
                    newDistance.wayPoints.push(Utils.createWayPoint(wp, newDistance.event, window.window.Cesium, window.viewer));
                });
                DistanceUtils.POST(newDistance)
                    .then(response => {
                        newDistance = response.data;
                        let race = Utils.createRace(this.raceParams.raceId, this.raceParams.raceName, this.raceParams.raceType, this.raceParams.raceStatus, this.raceParams.selectedIntreval[0], this.raceParams.selectedIntreval[1], (new Date(this.raceParams.selectedStartTime)).getTime(), newDistance.event, Utils.createRaceEntrys(this.raceEntrys), newDistance);
                        if(this.raceVideos != null && this.raceVideos != undefined) {
                            this.raceVideos.forEach(item => {
                                item.race.id = race.id;
                                item.shiftTimeline = race.raceStart;
                            });
                            race.videos = this.raceVideos;
                        }
                        RaceUtils.createOrUpdateRace(race).then(response => {
                            if (response.data != undefined) {
                                if (response.data.id != undefined && response.data.id != null && response.data.id.length == 36) {
                                    Utils.showMessage(this, this.$t('action.action.header'), this.$t('action.action.success'));
                                    this.handleClose();
                                    this.$emit("on-close", response.data);
                                }
                            } else {
                                Utils.showMessage(this, this.$t('action.action.errorHeader'), this.$t('action.action.error'));
                            }
                        }).catch(error => {
                            console.log("Error with creating race: " + error);
                            this.loading = false;
                            Utils.showMessage(this, this.$t('action.action.errorHeader'), this.$t('action.action.error'));
                        });
                    })
                    .catch(error => {
                        console.log("Error with creating distance: " + error);
                        this.loading = false;
                        Utils.showMessage(this, this.$t('action.action.errorHeader'), this.$t('action.action.errorDistance'));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            isTrack: function (row) {
                return row.type.id == 3;
            },
            createRaceEntry: function (id, boat, competitor) {
                return {
                    id: id,
                    boat: boat,
                    competitor: competitor
                }
            },
            addVideo: function() {
                this.raceVideos.push({
                    file: "new file",
                    shiftTimeline: 0,
                    shiftStart: 0,
                    playTime: 0,
                    deleted: false
                });
            },
            removeVideo: function(index) {
                //this.raceVideos.splice(index, 1);
                //this.raceVideos = [...this.raceVideos];
                this.raceVideos[index].deleted = true;
            },
            prepearedVideo: function(race) {

            }
        }
    }
</script>

<style>
    #trackCesiumContainer {
        margin-bottom: 5px;
    }

    .tab-wrapper {
        height: auto;
    }

    .cesium-viewer {
        height: calc(100vh - 210px) !important;
    }

    .tab-viewer {
        height: calc(100vh - 116px) !important;
    }

    .el-dialog--center .el-dialog__body {
        padding: 15px 25px 15px;
    }

    #bottom_widget {
        padding-right: 0;
    }

    .el-dialog__footer {
        padding-bottom: 10px;
    }

    .header_span {
        padding-top: 20px;
        display: block;
    }

    .icon-navigate_next:before {
        content: '\e409';
    }

    button.btn-responsive-nav {
        background: #171717 none repeat scroll 0 0;
        color: #fff;
        display: none;
        position: absolute;
        right: 16px;
        top: -41px;
        z-index: 15;
    }

    .mega-menu ul.nav {
        margin: 8px 0;
        padding: 0;
        clear: both;
        float: none;
        position: static;
        display: block;
        font-size: 13px;
    }

    .mega-menu ul.nav li {
        padding: 0;
        margin: 0;
        clear: both;
        float: none;
        display: block;
        border-bottom: 1px solid #2a2a2a;
    }

    .mega-menu ul.nav li + li {
        margin-left: 0;
    }

    .mega-menu ul.nav li a,
    .mega-menu ul.nav ul.dropdown-menu > li > a {
        text-shadow: none !important;
        padding: 9px 8px;
        border: 0 !important;
        border-top: 0;
        margin: 0;
        line-height: 24px;
    }

    .mega-menu ul.nav li:last-child,
    .mega-menu ul.dropdown-menu li > a {
        border-bottom: none;
    }

    .mega-menu ul.nav li a {
        color: white;
        clear: both;
        float: none;
        display: block;
        padding-left: 0;
    }

    .mega-menu ul.nav li a i.icon-angle-down {
        position: absolute;
        right: 5px;
        top: 14px;
    }

    .mega-menu ul.nav li.active a,
    .mega-menu ul.nav li > a:hover,
    .mega-menu ul.nav li.dropdown:hover a,
    .mega-menu ul.nav li.dropdown:hover ul.dropdown-menu li > a:hover {
        background: none !important;
    }

    .mega-menu ul.nav li a .icon {
        color: white !important;
    }

    .mega-menu ul.nav .more-items {
        line-height: 12px;
    }

    .mega-menu ul.nav ul {
        margin-left: 20px !important;
    }

    .mega-menu ul.nav .dropdown-menu {
        font-size: 13px;
        position: static;
        clear: both;
        float: none;
        display: none !important;
        box-shadow: none;
        border: none !important;
    }

    .mega-menu ul.nav li.resp-active > ul.dropdown-menu {
        display: block !important;
    }

    .mega-menu ul.nav ul.dropdown-menu,
    .mega-menu ul.nav li.dropdown.open a.dropdown-toggle,
    .mega-menu ul.nav li a,
    .mega-menu ul.nav li > a:hover,
    .mega-menu ul.nav li.active a,
    .mega-menu ul.nav li.dropdown:hover a,
    .mega-menu ul.nav ul.dropdown-menu li:hover > a,
    .mega-menu ul.nav li.dropdown:hover ul.dropdown-menu li > a:hover {
        background: none !important;
        background-color: transparent !important;
    }

    .mega-menu ul.nav .more-items .icon {
        display: block;
    }

    .el-dialog__header {
        padding-top: 10px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-tabs__header {
        margin-bottom: 0px;
    }

    @media (max-width: 767px) {
        header {
            display: block;
        }

        header > div.container {
            width: 100%;
        }

        header.center nav {
            width: auto;
        }

        header nav ul.nav-top {
            float: right;
            margin-right: 0;
        }

        button.btn-responsive-nav {
            background: #171717 none repeat scroll 0 0;
            color: #fff;
            display: none;
            position: absolute;
            right: 16px;
            top: -41px;
            z-index: 15;
        }
    }

    @media (max-width: 479px) {
        body {
            font-size: 13px;
        }

        header nav ul.nav-top,
        header div.header-top {
            display: none;
        }
    }

    @media (max-width: 600px) {
        header nav ul.nav-top li {
            display: none;
        }

        header nav ul.nav-top li.phone {
            display: block;
        }
    }

    .tabs .nav-tabs {
        border-bottom: 1px solid #d7dee3;
        margin: 0;
        text-transform: uppercase;
    }

    .tabs .nav-tabs a {
        -moz-border-bottom-colors: none;
        -moz-border-left-colors: none;
        -moz-border-right-colors: none;
        -moz-border-top-colors: none;
        background: #eff5f7 none repeat scroll 0 0;
        border-color: #dfe5e9 #dfe5e9 currentcolor;
        border-image: none;
        border-radius: 0;
        border-style: solid solid none;
        border-width: 1px 1px 0;
        color: #7a8790;
        margin-right: 1px;
        margin-top: 1px;
        text-decoration: none;
    }

    .tabs .nav-tabs li.active a {
        background: white none repeat scroll 0 0;
        border-top: 3px solid;
        margin-top: 0;
    }

    .tabs .nav-tabs a:hover {
        border-top: 2px solid;
        margin-top: 0;
    }

    .tabs .nav-tabs a:active,
    .tabs .nav-tabs a:focus {
        border-bottom: 0 none;
        margin-top: 0;
    }

    @media (min-width: 992px) {
        .body_media {
            top: 2px;
        }

        .mega-menu ul.nav {
            position: static;
        }

        .mega-menu ul.nav .more-items .icon {
            display: none;
        }

        header .nav-main-collapse.collapse {
            display: block;
        }

        .mega-menu ul.nav.responsive-menu {
            display: none;
        }

        section.page-top .container {
            width: 970px;
        }
    }

    @media (min-width: 1200px) {
        section.page-top .container {
            width: 1140px;
        }
    }

    @media (max-width: 991px) {
        .body_media {
            top: 1px;
        }

        .mega-menu ul.nav li a {
            color: white;
        }

        header .nav-main-collapse {
            background: #171717 none repeat scroll 0 0;
            max-height: none;
            overflow: hidden;
            position: relative;
            top: 60px;
            width: 100%;
            z-index: 10;
        }

        header .nav-main-collapse.collapse {
            display: none;
        }

        header .nav-main-collapse.in {
            display: block;
        }

        header.menu-type-2 .nav-main-collapse {
            top: 0;
        }

        header > .container {
            margin-bottom: 0;
        }

        header .hidable {
            display: none;
        }

        button.btn-responsive-nav {
            display: block;
        }

        .table-menu {
            display: none;
        }

        .responsive-menu {
            display: block;
        }

        .mega-menu {
            clear: both;
            display: block;
            float: none;
            padding: 10px 0;
            width: 100%;
        }

        .social-icons {
            display: none;
        }

        footer .info {
            padding-bottom: 34px;
        }
    }

    @media (max-width: 767px) {
        .body_media {
            top: 0;
        }

        .social-icons {
            display: none;
        }

        .top-row .info-text .email,
        .top-row .info-text .skype {
            margin-left: 11px;
        }

        .top-row .info-text .email,
        .top-row .info-text .phone {
            margin-left: 0;
        }
    }

    footer {
        border-color: #0088cc;
    }

    footer .menu li.active a {
        color: #0088cc;
    }

    footer .menu li a:hover {
        color: #0088cc;
    }

    .col-md-3-tar {
        text-align: right;
    }

    @media (max-width: 993px) {
        .col-md-3-tar {
            text-align: left;
        }
    }

    @media (max-width: 360px) {
        button.btn-responsive-nav {
            position: absolute;
            right: 16px;
            top: -144px;
        }
    }

</style>
